import ReactDOM from "react-dom";
import { createRoot } from "react-dom/client";
import React, { useEffect, useReducer } from "react";
import PostPurchaseBlock from "./components/PostPurchaseBlock";
import Header from "./components/Header";
import Breadcrumbs from "./components/Breadcrumbs";
import {
  PostPurchaseContext,
  PostPurchaseDispatchContext,
} from "./context/PostPurchaseContext";
import Step4 from "./components/Forms/Step4";
import Step5 from "./components/Forms/Step5";

const PostPurchase = () => {
  const data = JSON.parse(rootElement.dataset.sectionData);
  function reducer(state, action) {
    switch (action.type) {
      case "setActiveStep":
        return { ...state, activeStep: action.payload };
      case "setCustomerData":
        if (
          action.payload.name === "noExtendedWarranty" &&
          action.payload.value === true
        ) {
          state = { ...state, cart: { ...state.cart, extendedWarranty: null } };
        }
        return { ...state, [action.payload.name]: action.payload.value };
      case "setExistingSku":
        return { ...state, existingSku: action.payload.value };
      case "updateCart":
        const newNoExtendedWarranty =
          action.payload.name === "extendedWarranty"
            ? false
            : state.noExtendedWarranty;
        if (action.payload.name === "filters") {
          const uniqueFilters = state.cart.filters.filter(
            (filter) => filter.productId !== action.payload.value.productId
          );
          return {
            ...state,
            noExtendedWarranty: newNoExtendedWarranty,
            cart: {
              ...state.cart,
              [action.payload.name]: [...uniqueFilters, action.payload.value],
            },
          };
        }
        return {
          ...state,
          noExtendedWarranty: newNoExtendedWarranty,
          cart: { ...state.cart, [action.payload.name]: action.payload.value },
        };
    }
  }
  const initialState = {
    data,
    // TODO: Replace initial values
    activeStep: null, // Initial value should be null
    firstName: "", // Initial value should be empty string
    lastName: "", // Initial value should be empty string
    email: "", // Initial value should be empty string
    emailNotifications: false, // Initial value should be false
    phoneNumber: "", // Initial value should be empty string
    smsNotifications: false, // Initial value should be false
    modelNumber: "", // Initial value should be empty string
    productName: "", // Initial value should be empty string
    serialNumber: "", // Initial value should be empty string
    existingSku: "", // Initial value should be empty string
    purchaseDate: "", // Initial value should be ''
    purchasePlace: "", // Initial value should be empty string
    proofOfPurchase: [],
    proofOfPurchaseUrl: "",
    cart: { extendedWarranty: null, kit: null, filters: [] },
    noExtendedWarranty: false, // Initial value should be false
    kitData: null,
    filtersData: [null],
    warrantyProducts: data.warranty_products,
    klaviyoListId: data.list_id,
  };
  const [state, dispatch] = useReducer(reducer, initialState);
  // useEffect(() => {
  //   const storedState = JSON.parse(localStorage.getItem("state"));

  //   if (storedState?.activeStep && storedState.activeStep <= 4) {
  //     dispatch({
  //       type: "setActiveStep",
  //       payload: storedState.activeStep,
  //     });
  //   }
  // }, []);

  // useEffect(() => {
  //   if (state !== initialState) {
  //     const stateString = JSON.stringify(state);
  //     localStorage.setItem("state", stateString);
  //   }
  // }, [state]);

  return (
    <PostPurchaseContext.Provider value={state}>
      <PostPurchaseDispatchContext.Provider value={dispatch}>
        <div className="max-w-[900px] my-12 m-auto">
          <div className="p-8">
            {/* Header Block */}
            <div className="flex flex-col gap-y-5 flex-wrap content-center lg:flex-row lg:justify-around">
              <Header image={data.header_image} />
              <div className="w-1 bg-muted-400"></div>
              <Breadcrumbs blocks={data.blocks} />
            </div>

            {/* Body Block */}
            <div className="text-center my-16 lg:max-w-5xl lg:m-auto">
              {!state.activeStep && (
                <>
                  <h1 className="text-[28px] font-bold text-[#3C69B1] pb-8 normal-case lg:pt-16">
                    {data.title}
                  </h1>
                  <p className="pb-8 leading-10">{data.description}</p>
                  <button
                    onClick={() =>
                      dispatch({ type: "setActiveStep", payload: 1 })
                    }
                    className="px-[20px] py-[18px] bg-brio-300 text-white rounded-[16px] font-bold text-3xl"
                  >
                    Let's Get Started
                  </button>
                </>
              )}
            </div>
          </div>
          <div className="max-w-[900px] my-12 m-auto">
            {data.blocks.map((block) => (
              <PostPurchaseBlock key={block.id} block={block} />
            ))}
          </div>
          {state.activeStep == 4 && <Step4 />}
          {state.activeStep == 5 && <Step5 />}
        </div>
      </PostPurchaseDispatchContext.Provider>
    </PostPurchaseContext.Provider>
  );
};

const rootElement = document.querySelector("#post-purchase-root");
const root = createRoot(rootElement);
root.render(<PostPurchase />);
